import script from "./BlogPopup.vue?vue&type=script&lang=ts&setup=true"
export * from "./BlogPopup.vue?vue&type=script&lang=ts&setup=true"

import "./BlogPopup.vue?vue&type=style&index=0&id=39c839cf&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39c839cf"]])

export default __exports__